import type { UserRole, UserType } from '@baseball-near-you/common';
import type { User } from '@baseball-near-you/prisma';
import { dayjsExt } from '../dayjs';

export const getCreateNewUserPayload = (userData: {
  id: string;
  email: string | null;
  emailVerified: string | null;
  phone: string | null;
  image: string | null;
  role: UserRole | 'Team Associate' | null;
  type: UserType | null;
  marketingOptIn: boolean;
}): User => {
  return {
    id: userData.id,
    createdAt: new Date(),
    updatedAt: new Date(),
    completedOnboarding: null,
    email: userData.email ?? null,
    emailVerified: userData.emailVerified
      ? dayjsExt(userData.emailVerified).toDate()
      : null,
    marketingOptIn: userData.marketingOptIn,
    image: userData.image ?? null,
    role: userData.role ?? null,
    type: userData.type ?? null,
    phoneNumber: userData.phone ?? null,
    isAdmin: false,
    teamId: null,
    firstName: null,
    lastName: null,
    referralSource: null,
    birthday: null,
    graduationYear: null,
    parentFirstName: null,
    parentLastName: null,
    state: null,
    schoolName: null,
    batHandedness: null,
    throwHandedness: null,
    positions: [],
  };
};
